import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogDataInterface } from '../modal-custom-date/dialog-data.interface';
import { ProfileportfolioService, TechDropdownItemInterface } from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';

@Component({
  selector: 'tech-modal-custom-date-report',
  templateUrl: './modal-custom-date-report.component.html',
  styleUrls: ['./modal-custom-date-report.component.scss'],
})

export class ModalCustomDateReportComponent implements OnInit,AfterViewInit {
  public arrperiods = [];

  initialDateForm = new UntypedFormControl(new Date(this.data.initialDate));
  endDateForm = new UntypedFormControl(new Date(this.data.endDate));
  periodForm = new UntypedFormControl(new String(this.data.period));

  showDatePickers = false;
  minDate: Date;
  maxDate: Date;
  selectedPeriod: string;
  initialDate: Date;
  endDate: Date;
  disableConfirm: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalCustomDateReportComponent>,
    private _adapter: DateAdapter<any>,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataInterface,
    private profilePortfolioService: ProfileportfolioService,
  ) {
    this.initialDate = new Date(this.data.initialDate);
    this.endDate = new Date(this.data.endDate);
    this.minDate = new Date(this.data.minDate);
    this.maxDate = new Date(this.data.maxDate);

    this._adapter.setLocale(localStorage.getItem('Language'));
  }
  ngAfterViewInit(): void {
  }


  ngOnInit() {
    setTimeout(() => {
      this.commonService.loading$.emit(true);

      this.profilePortfolioService
      .getFixedperiods(this.data.portfolioCode)
      .subscribe((data) => {
        this.arrperiods = [];
        let pstartdate = data.find((p) => p.Period == 'PeriodStartDate');
        if (pstartdate) this.arrperiods.push(pstartdate);
        let p1w = data.find((p) => p.Period == 'Period1W');
        if (p1w) this.arrperiods.push(p1w);
        let p1m = data.find((p) => p.Period == 'Period1M');
        if (p1m) this.arrperiods.push(p1m);
        let p3m = data.find((p) => p.Period == 'Period3M');
        if (p3m) this.arrperiods.push(p3m);
        let p1y = data.find((p) => p.Period == 'Period1Y');
        if (p1y) this.arrperiods.push(p1y);
        let pytd = data.find((p) => p.Period == 'PeriodYTD');
        if (pytd) this.arrperiods.push(pytd);
        let pcustomize = data.find((p) => p.Period == 'PeriodCustom');
        if (pcustomize) this.arrperiods.push(pcustomize);
        this.selectedPeriod = 'PeriodStartDate';
        this.commonService.loading$.emit(false);
      },(err) => {
        this.commonService.errorManager('getFixedperiods', err);
        this.commonService.loading$.next(false);
        this.dialogRef.close();
      });
    });

  }

  addDate(type: string, event: MatDatepickerInputEvent<Date>) {
    switch (type) {
      case 'initialDate':
        this.initialDate = event.value;
        break;
      case 'endDate':
        if (event.value <= this.maxDate) {
          this.endDate = event.value;
          this.disableConfirm = false;
        } else {
          this.disableConfirm = true;
        }
        break;
      default:
        break;
    }
  }

  onPeriodChange(e)
  {
    this.selectedPeriod = e.value;
    if (e.value==='PeriodCustom')
    {
      this.showDatePickers = true;
    }
    else
    {
      this.showDatePickers = false;
    }

    let period = this.arrperiods.find((p) => p.Period == e.value);

    this.initialDate = new Date(period.PeriodInitialtDate);
    this.endDate = new Date(period.PeriodEndDate);

    //this.initialDateForm.setValue(this.initialDate);
    //this.endDateForm.setValue(this.endDate);

  }
}
